import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { ElMessageBox } from "element-plus";
import 'element-plus/es/components/message-box/style/index'

export default defineComponent({
  components: {
    Pagination: Pagination
  },
  props: {
    apiName: {
      required: true,
      type: String,
      default: ""
    },
    // 状态切换
    tabsIndex: {
      type: Number,
      default: 0
    },
    // 分类切换
    topTabsIndex: {
      type: Number,
      default: 0
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  emits: ["update:totalNum"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; //来源标示


    var source = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_source; //表格数据

    var tableData = ref([]); // 分页属性    

    var totalNum = ref(0);
    var pageIndex = ref(1); // 表格加载

    var loading = ref(false); // 分页初始化

    function initData() {
      loading.value = false;
      totalNum.value = 0;
      pageIndex.value = 1;
      tableData.value = [];
      getTabledata();
    } // 列表获取


    function getTabledata() {
      return _getTabledata.apply(this, arguments);
    }

    function _getTabledata() {
      _getTabledata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page, _yield$globalProperti, data, total, code;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = true;
                page = {
                  pageIndex: pageIndex.value,
                  pageSize: 10
                };
                _context.next = 4;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[props.apiName](Object.assign(page, props.conditions));

              case 4:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                total = _yield$globalProperti.total;
                code = _yield$globalProperti.code;

                if (code == 0) {
                  totalNum.value = total;
                  tableData.value = data;

                  if (props.tabsIndex == 0) {
                    emit("update:totalNum", total);
                  }

                  loading.value = false;
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getTabledata.apply(this, arguments);
    }

    function handleDelete(val) {
      var myDate = new Date(val.startTime);
      var newe = new Date().getTime();

      if (myDate.getTime() > newe) {
        ElMessageBox.alert("\u8BC4\u8BAE\u5C1A\u672A\u5F00\u59CB", "提示", {
          type: 'warning',
          confirmButtonText: "确定",
          callback: function callback(action) {
            console.log(action);
          }
        });
      } else {
        if (props.topTabsIndex == 0) {
          router.push({
            path: 'evaluator',
            query: {
              id: 0,
              userId: val.listId
            }
          });
        } else {
          router.push({
            path: 'evaluator',
            query: {
              id: 1,
              userId: val.listId
            }
          });
        }
      }
    }

    function hisoryDelete(val) {
      console.log(val);

      if (props.topTabsIndex == 1) {
        router.push({
          path: 'reviewee',
          query: {
            listId: val.listId
          }
        });
      } else {
        router.push({
          path: 'historyRecord',
          query: {
            listId: val.listId
          }
        });
      }
    }

    function changPage(val) {
      loading.value = false;
      pageIndex.value = val;
      tableData.value = [];
      getTabledata();
    }

    return {
      tableData: tableData,
      totalNum: totalNum,
      source: source,
      getTabledata: getTabledata,
      changPage: changPage,
      initData: initData,
      // 开始
      handleDelete: handleDelete,
      // 查看
      hisoryDelete: hisoryDelete
    };
  }
});